import * as licenses from './licenses.ts';

export { licenses };
